<template>
  <section class="animate-fade-in">
    <img class="logo" :src="require('@/assets/2025/images/00_logo.png')" alt="로고" />
    <p>만 19세 이상 이용 가능합니다. <br />계속하시려면 아래 생년월일을 입력하세요.</p>
    <div class="select">
      <div class="custom-select-wrapper">
        <div class="custom-select-display" @click="toggleYearDropdown" @keydown.enter.prevent="toggleYearDropdown" tabindex="0" ref="yearDisplay">
          <span>{{ year || 'YY' }}</span>
          <span class="arrow">{{ showYearDropdown ? '▲' : '▼' }}</span>
        </div>
        <ul v-if="showYearDropdown" class="custom-select-dropdown" ref="yearDropdown">
          <li v-for="y in years" :key="y" :class="{ selected: y === year }" @mousedown.prevent="selectYear(y)">
            {{ y }}
          </li>
        </ul>
      </div>
      <div class="custom-select-wrapper">
        <div class="custom-select-display" @click="toggleMonthDropdown" @keydown.enter.prevent="toggleMonthDropdown" tabindex="0" ref="monthDisplay">
          <span>{{ month ? (month < 10 ? `0${month}` : month) : 'MM' }}</span>
          <span class="arrow">{{ showMonthDropdown ? '▲' : '▼' }}</span>
        </div>
        <ul v-if="showMonthDropdown" class="custom-select-dropdown" ref="monthDropdown">
          <li v-for="m in months" :key="m" :class="{ selected: m === month }" @mousedown.prevent="selectMonth(m)">
            {{ m < 10 ? `0${m}` : m }}
          </li>
        </ul>
      </div>
    </div>
    <button class="enter" type="button" @click="checkAdult">
      ENTER
      <!-- <img :src="require('@/assets/2025/images/00_btn_enter.png')" alt="확인" /> -->
    </button>
    <p class="warning">
      경고: 지나친 음주는 뇌졸중, 기억력 손상이나 치매를 유발합니다. <br />
      임신 중 음주는 기형아 출생 위험을 높입니다.
    </p>
  </section>
</template>
<script setup>
import { ref, computed, onMounted, defineEmits, nextTick } from 'vue'

const year = ref('')
const month = ref('')
const result = ref(null)
const years = ref([])
const months = ref([])
const showYearDropdown = ref(false)
const yearDropdown = ref(null)
const yearDisplay = ref(null)
const showMonthDropdown = ref(false)
const monthDropdown = ref(null)
const monthDisplay = ref(null)

const yearMonth = computed(() => {
  return `${year.value}-${month.value < 10 ? `0${month.value}` : month.value}`
})

const birthAge = computed(() => {
  if (year.value && month.value) {
    const today = new Date()
    const birth = new Date(year.value, month.value - 1, 1)
    const age = today.getFullYear() - birth.getFullYear()
    const m = today.getMonth() - birth.getMonth()
    return m > 0 || (m === 0 && today.getDate() >= 1) ? age : age - 1
  }
  return null
})

const emit = defineEmits(['adultCheck'])

function checkAdult() {
  if (!year.value || !month.value) {
    result.value = null
    sessionStorage.removeItem('birthInfo')
    alert('출생 연도와 월을 모두 선택해 주세요.')
    return
  }
  sessionStorage.setItem(
    'birthInfo',
    JSON.stringify({
      year: year.value,
      month: month.value,
      yearMonth: yearMonth.value,
      age: birthAge.value
    })
  )
  emit('adultCheck', birthAge.value >= 19)
}

function toggleYearDropdown() {
  showYearDropdown.value = !showYearDropdown.value
  if (showYearDropdown.value) {
    nextTick(() => {
      scrollToSelectedYearCustom()
      document.addEventListener('click', onClickOutsideYear, true)
    })
  } else {
    document.removeEventListener('click', onClickOutsideYear, true)
  }
}

function selectYear(y) {
  year.value = y
  showYearDropdown.value = false
  document.removeEventListener('click', onClickOutsideYear, true)
  nextTick(() => {
    yearDisplay.value && yearDisplay.value.focus()
  })
}

function onClickOutsideYear(e) {
  if (yearDropdown.value && !yearDropdown.value.contains(e.target) && yearDisplay.value && !yearDisplay.value.contains(e.target)) {
    showYearDropdown.value = false
    document.removeEventListener('click', onClickOutsideYear, true)
  }
}

function scrollToSelectedYearCustom() {
  nextTick(() => {
    const dropdown = yearDropdown.value
    let selected = dropdown?.querySelector('.selected')
    // 선택된 값이 없으면 1992년 li를 찾음
    if (!selected && dropdown) {
      selected = Array.from(dropdown.children).find(li => li.textContent.trim() === '1992')
    }
    if (dropdown && selected) {
      const dropdownHeight = dropdown.clientHeight
      const optionHeight = selected.offsetHeight
      dropdown.scrollTop = selected.offsetTop - dropdownHeight / 2 + optionHeight / 2
    }
  })
}

function toggleMonthDropdown() {
  showMonthDropdown.value = !showMonthDropdown.value
  if (showMonthDropdown.value) {
    nextTick(() => {
      scrollToSelectedMonthCustom()
      document.addEventListener('click', onClickOutsideMonth, true)
    })
  } else {
    document.removeEventListener('click', onClickOutsideMonth, true)
  }
}

function selectMonth(m) {
  month.value = m
  showMonthDropdown.value = false
  document.removeEventListener('click', onClickOutsideMonth, true)
  nextTick(() => {
    monthDisplay.value && monthDisplay.value.focus()
  })
}

function onClickOutsideMonth(e) {
  if (monthDropdown.value && !monthDropdown.value.contains(e.target) && monthDisplay.value && !monthDisplay.value.contains(e.target)) {
    showMonthDropdown.value = false
    document.removeEventListener('click', onClickOutsideMonth, true)
  }
}

function scrollToSelectedMonthCustom() {
  nextTick(() => {
    const dropdown = monthDropdown.value
    const selected = dropdown?.querySelector('.selected')
    if (dropdown && selected) {
      const dropdownHeight = dropdown.clientHeight
      const optionHeight = selected.offsetHeight
      dropdown.scrollTop = selected.offsetTop - dropdownHeight / 2 + optionHeight / 2
    }
  })
}

onMounted(() => {
  for (let y = 1970; y <= 2025; y++) {
    years.value.push(y)
  }
  for (let m = 1; m <= 12; m++) {
    months.value.push(m)
  }
  const birthInfo = sessionStorage.getItem('birthInfo')
  if (birthInfo) {
    const savedBirthInfo = JSON.parse(birthInfo)
    year.value = savedBirthInfo.year
    month.value = savedBirthInfo.month
  }
})
</script>

<style scoped>
section {
  width: var(--contents-width);
  max-width: var(--max-contents-width);
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10vw;
  background-image: url('@/assets/2025/images/00_bg.png');
  flex: 1 0 auto;
  background-size: cover;
  background-repeat: no-repeat;
}
section * {
  max-width: 100%;
  font-family: 'NanumSquare', sans-serif;
  line-height: 1.5;
}
section > p {
  text-align: center;
  margin-bottom: 6vh;
  font-size: 1rem;
  word-break: keep-all;
}
section p.warning {
  font-size: 0.65rem;
  color: #747474;
  text-align: center;
  margin: auto 0 6vh 0;
}
section .logo {
  margin: 18vh auto 6vh auto;
  width: 30vw;
  aspect-ratio: 135 / 107;
}
section .enter {
  /* background: none; */
  border: none;
  width: 100%;
  height: 3rem;
  border-radius: 1.5rem;
  font-size: 1.1rem;
  color: #000;
}
section div.select {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 5vw;
  margin-bottom: 3vh;
}
section div.select label {
  width: 100%;
  height: 2.5rem;
}
section div.select select {
  width: 100%;
  border-radius: 1.25rem;
  color: #ffffff;
  font-size: 1.1rem;
  height: 100%;
  text-align: center;
  background-color: #55504d;
}
.custom-select-wrapper {
  position: relative;
  width: 100%;
}
.custom-select-display {
  width: 100%;
  height: 2.5rem;
  border-radius: 1.25rem;
  background-color: #55504d;
  color: #fff;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  cursor: pointer;
  outline: none;
}
.custom-select-display .arrow {
  margin-left: 0.5rem;
  font-size: 0.9em;
}
.custom-select-dropdown {
  position: absolute;
  top: 110%;
  left: 0;
  width: 100%;
  max-height: 18rem; /* 더 많은 옵션이 보이도록 높이 증가 */
  overflow-y: auto;
  background: #55504d;
  border-radius: 1.25rem;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 0.25rem 0;
}
.custom-select-dropdown li {
  padding: 0.5rem 1rem;
  cursor: pointer;
  color: #fff;
  font-size: 1.1rem;
}
.custom-select-dropdown li.selected,
.custom-select-dropdown li:hover {
  background: #7a7673;
}
/* 스크롤바 커스텀 */
.custom-select-dropdown::-webkit-scrollbar {
  width: 6px;
  background: transparent;
}
.custom-select-dropdown::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.custom-select-dropdown::-webkit-scrollbar-track {
  background: transparent;
}
.custom-select-dropdown {
  scrollbar-width: thin;
  scrollbar-color: #888 #55504d;
}
@media (min-width: 640px) {
  section {
    padding: 0 3%;
    width: auto;
    max-width: var(--desktop-contents-width);
    min-height: var(--desktop-contents-height);
  }
  section .logo {
    width: 40%;
  }
  section > p {
    font-size: 1.2rem;
  }
  section p.warning {
    font-size: 0.75rem;
  }
  section div.select {
    gap: 1.5rem;
  }
  section div.select select {
    font-size: 1.2rem;
  }
}
</style>
